import { DataBean } from "../DataBean";

export class DepreciationQuota extends DataBean {



    public async importUpdateForDepreciationQuotaCalculated(filename: any, directory: any, dataStore: any, year: any, month: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importUpdateForDepreciationQuotaCalculated_String_String_String_Number_Number", [filename, directory, dataStore, year, month]);
    }

}